import type { Consultation } from '@shared/types/consultations';

export const consultationStatus = (consultation?: Consultation) => {
	if (!consultation) return 'notPayed';
	let status = 'notPayed';

	if (consultation.paid.paid && consultation.confirmed) {
      status = 'confirmed';
	}

	if (consultation.cancelled) {
		status = 'cancelled';
	}

	if (!consultation.paid.paid && consultation.paid.transaction) {
		status = 'awaitingPayment';
	}

	if (!consultation.paid.paid && !consultation.paid.transaction) {
		status = 'notPayed';
	}

	if (consultation.paid.paid && !consultation.confirmed) {
		status = 'unconfirmed';
	}

	return status;
};
